<template>
  <div class="micro-router">
    主应用
    <br>
    <div @click="initAdmin">素养项目</div>
    <br>
    <div @click="initVue">测试vue</div>
    <br>
    <router-link to="/TMS/micro/react//">React</router-link>
    <br>
    ========================================
    <div id="TMSCourse">vue</div>
    <div id="TMSAdmin">admin</div>
  </div>
</template>

<script>
  import { loadMicroApp } from 'qiankun'
  export default {
    components: {
    },
    watch: {

    },
    data() {
      return {
      }
    },

    methods: {
      initAdmin() {
        loadMicroApp(
          {
            name: 'admin',
            description: '素养管理后台',
            entry: 'http://localhost:9528',
            container: '#TMSAdmin',
          },
        )
      },
      initVue() {
        loadMicroApp(
          {
            name: 'VEU-HASH',
            description: '测试vue',
            entry: 'http://localhost:1111/#/about',
            container: '#TMSCourse',
          },
        )
      },
      initMicro() {
      }
    },

    mounted() {
    }
  }
</script>

<style lang="less">
  .micro-router {

  }
</style>
